import { FactoryProvider, InjectionToken } from '@angular/core';
import { AiRequestContext } from '../endpoint-contracts/context';

/** Returns the fields this contributor adds to every request's `context`. Called at send time. */
export type AiRequestContextContributor = () => Partial<AiRequestContext>;

export const AI_REQUEST_CONTEXT_CONTRIBUTORS = new InjectionToken<AiRequestContextContributor[]>('__AI_REQUEST_CONTEXT_CONTRIBUTORS__', {
    factory: (): AiRequestContextContributor[] => []
});

/**
 * Adds fields to the request context of every prompt and init-thread call.
 * The factory runs in injection context, like the interceptor factories.
 * Later contributors overwrite earlier ones per top-level key; per-prompt `contextExtras` overwrite all of them.
 */
export function provideAiRequestContextContributor(factory: (...deps: unknown[]) => AiRequestContextContributor): FactoryProvider {
    return { provide: AI_REQUEST_CONTEXT_CONTRIBUTORS, useFactory: factory, multi: true };
}
